/* ============================================================
   md-footer.js
   Detecta se o rodape esta rodando dentro do app oficial da
   Shopify (Shop app / Shop Pay webview). Quando sim, adiciona
   a classe .md-footer--app no <html> pra esconder o seletor de
   pais (o proprio app ja faz a troca de pais fora do rodape).
   Sem app, nao mexe em nada.
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function detectApp() {
    try {
      var ua = (window.navigator && window.navigator.userAgent) || '';
      var pattern = /ShopifyApp|Shop Pay|com\.shopify\.Shop|ShopApp/i;
      if (pattern.test(ua)) {
        document.documentElement.classList.add('md-footer--app');
      }
    } catch (e) {
      /* UA indisponivel: segue sem marcar app */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', detectApp, { once: true });
  } else {
    detectApp();
  }
})();
